import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0836b150"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid grid-cols-1 gap-3" }
const _hoisted_2 = { class: "font-semibold" }
const _hoisted_3 = { class: "flex items-center gap-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus mr-2" }, null, -1))
const _hoisted_6 = { class: "SlaActions__inputs" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_select = _resolveComponent("the-select")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "xxl SlaActions",
    title: _ctx.modalTitle,
    "confirm-button-text": _ctx.modalConfirmButtonText,
    "confirm-button-class": _ctx.isDelete ? 'small red' : undefined,
    "confirm-message": `Вы действительно хотите удалить SLA (id: ${_ctx.state.id})?`,
    "is-confirm": _ctx.isDelete,
    loading: _ctx.loading,
    scrollable: "",
    onCancel: _ctx.emitCancel,
    onConfirm: _ctx.emitManager
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_the_select, {
          value: _ctx.state.city_from,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.city_from) = $event)),
          placeholder: "Откуда",
          "is-invalid": _ctx.state_form$.city_from.$error,
          "validation-errors": _ctx.state_form$.city_from.$errors,
          loading: _ctx.data_state.from_cities.is_loading,
          options: _ctx.data_state.from_cities.list,
          failed: _ctx.data_state.from_cities.is_failed,
          "error-text": "При получении списка городов произошла ошибка",
          "search-by": "name",
          label: "name",
          "infinite-scroll": "",
          onRefresh: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadFromCities(_ctx.data_state.from_cities.pagination.current_page))),
          onLoadmore: _cache[2] || (_cache[2] = ($event: any) => (_ctx.loadMoreFromCities(_ctx.data_state.from_cities.pagination.current_page + 1))),
          onSearch: _ctx.searchFromCity,
          onOptionBySearch: _ctx.unshiftFindedFromCity
        }, null, 8, ["value", "is-invalid", "validation-errors", "loading", "options", "failed", "onSearch", "onOptionBySearch"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.transit_cities, (city, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: `transit-city-${i}`,
            class: "grid grid-cols-1 gap-3"
          }, [
            _createElementVNode("div", _hoisted_2, "Транзит №" + _toDisplayString(i + 1), 1),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_the_select, {
                class: "w-full",
                value: _ctx.state.transit_cities[i],
                "onUpdate:value": ($event: any) => ((_ctx.state.transit_cities[i]) = $event),
                placeholder: "Выберите из списка",
                loading: _ctx.data_state.transit_cities.is_loading,
                disabled: _ctx.data_state.transit_cities.is_loading,
                failed: _ctx.data_state.transit_cities.is_failed,
                options: _ctx.data_state.transit_cities.list,
                "error-text": "При получении списка городов произошла ошибка",
                onRefresh: _ctx.loadTransitCities
              }, null, 8, ["value", "onUpdate:value", "loading", "disabled", "failed", "options", "onRefresh"]),
              _createVNode(_component_the_button, {
                class: "red text small",
                onClick: ($event: any) => (_ctx.deleteTransitCity(i))
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]))
        }), 128)),
        _createVNode(_component_the_button, {
          class: "primary text small",
          onClick: _ctx.addTransitCity
        }, {
          default: _withCtx(() => [
            _hoisted_5,
            _createTextVNode(" Добавить город транзит ")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_the_select, {
          value: _ctx.state.city_to,
          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.city_to) = $event)),
          placeholder: "Куда",
          "is-invalid": _ctx.state_form$.city_to.$error,
          "validation-errors": _ctx.state_form$.city_to.$errors,
          loading: _ctx.data_state.to_cities.is_loading,
          options: _ctx.data_state.to_cities.list,
          failed: _ctx.data_state.to_cities.is_failed,
          "error-text": "При получении списка городов произошла ошибка",
          "search-by": "name",
          label: "name",
          "infinite-scroll": "",
          onRefresh: _cache[4] || (_cache[4] = ($event: any) => (_ctx.loadToCities(_ctx.data_state.to_cities.pagination.current_page))),
          onLoadmore: _cache[5] || (_cache[5] = ($event: any) => (_ctx.loadMoreToCities(_ctx.data_state.to_cities.pagination.current_page + 1))),
          onSearch: _ctx.searchToCity,
          onOptionBySearch: _ctx.unshiftFindedToCity
        }, null, 8, ["value", "is-invalid", "validation-errors", "loading", "options", "failed", "onSearch", "onOptionBySearch"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_the_select, {
          class: "mt-2",
          value: _ctx.state.periodId,
          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.periodId) = $event)),
          placeholder: "Период",
          options: _ctx.PERIOD_OPTIONS
        }, null, 8, ["value", "options"]),
        _createVNode(_component_the_input, {
          value: _ctx.state.pickup,
          "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.pickup) = $event)),
          "is-invalid": _ctx.state_form$.pickup.$error,
          "validation-errors": _ctx.state_form$.pickup.$errors,
          placeholder: "Забор"
        }, null, 8, ["value", "is-invalid", "validation-errors"]),
        _createVNode(_component_the_input, {
          value: _ctx.state.processing,
          "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.processing) = $event)),
          "is-invalid": _ctx.state_form$.processing.$error,
          "validation-errors": _ctx.state_form$.processing.$errors,
          placeholder: "Обработка"
        }, null, 8, ["value", "is-invalid", "validation-errors"]),
        _createVNode(_component_the_input, {
          value: _ctx.state.transit,
          "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.transit) = $event)),
          "is-invalid": _ctx.state_form$.transit.$error,
          "validation-errors": _ctx.state_form$.transit.$errors,
          placeholder: "Транзит"
        }, null, 8, ["value", "is-invalid", "validation-errors"]),
        _createVNode(_component_the_input, {
          value: _ctx.state.delivery,
          "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.delivery) = $event)),
          "is-invalid": _ctx.state_form$.delivery.$error,
          "validation-errors": _ctx.state_form$.delivery.$errors,
          placeholder: "Доставка"
        }, null, 8, ["value", "is-invalid", "validation-errors"]),
        _createVNode(_component_the_select, {
          class: "mt-2",
          value: _ctx.state.tariff,
          "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.tariff) = $event)),
          placeholder: "Тариф",
          "is-invalid": _ctx.state_form$.tariff.$error,
          "validation-errors": _ctx.state_form$.tariff.$errors,
          loading: false,
          options: _ctx.SlaTariffs,
          "search-by": "name",
          "select-by": "api_key",
          label: "name",
          onChange: _ctx.onTariffChange
        }, null, 8, ["value", "is-invalid", "validation-errors", "options", "onChange"]),
        (_ctx.isExpress)
          ? (_openBlock(), _createBlock(_component_the_select, {
              key: 0,
              value: _ctx.state.supplier_id,
              "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.supplier_id) = $event)),
              placeholder: "Поставщик",
              loading: false,
              options: _ctx.SLA_CARRIERS,
              "search-by": "name",
              label: "name",
              class: "mt-1"
            }, null, 8, ["value", "options"]))
          : _createCommentVNode("", true),
        (_ctx.isExpress)
          ? (_openBlock(), _createBlock(_component_checkbox, {
              key: 1,
              label: "Активный",
              value: _ctx.state.is_active,
              "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.is_active) = $event)),
              disabled: _ctx.loading
            }, null, 8, ["value", "disabled"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["title", "confirm-button-text", "confirm-button-class", "confirm-message", "is-confirm", "loading", "onCancel", "onConfirm"]))
}